export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15206.44b3e596.jpg";